import { ThumbsUp, ThumbsDown, Star } from 'lucide-react';
import * as React from 'react';
import { Card } from '#app/components/ui/card';
import { Separator } from '#app/components/ui/separator';
import EVStationTags from './tags';

export default function Ratings({
  totalRatings,
  positiveRatings,
  negativeRatings,
  tags,
}: {
  totalRatings: number;
  positiveRatings: number;
  negativeRatings: number;
  tags: any; // Consider defining a more specific type for tags
}) {
  // Handle division by zero
  const positivePercentage =
    totalRatings > 0 ? (positiveRatings / totalRatings) * 100 : 0;

  // Function to determine the color based on the percentage
  const getColorClass = (percentage: number): string => {
    if (totalRatings === 0) return 'bg-gray-300'; // Neutral color for no ratings
    if (percentage <= 30) return 'bg-red-500';
    if (percentage <= 60) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const colorClass = getColorClass(positivePercentage);

  return (
    <Card className='overflow-hidden bg-white shadow-sm backdrop-blur-sm'>
      <div className='p-5'>
        <div className='mb-4 flex items-center gap-2'>
          <Star className='h-5 w-5 text-primary' />
          <h3 className='text-lg font-semibold'>
            Avaliações{' '}
            <span className='text-sm font-normal text-muted-foreground'>
              ({totalRatings})
            </span>
          </h3>
        </div>
        <div className='space-y-4'>
          {totalRatings > 0 ? (
            <div className='flex items-center space-x-3'>
              <div className='flex items-center space-x-1'>
                <ThumbsUp className='h-4 w-4 text-green-500' />
                <span className='text-xs font-medium text-muted-foreground'>
                  {positiveRatings}
                </span>
              </div>
              <div className='relative flex-1'>
                <div className='h-2.5 w-full rounded-full bg-gray-200'>
                  <div
                    className={`${colorClass} h-2.5 rounded-full transition-all duration-300 ease-in-out`}
                    style={{ width: `${positivePercentage}%` }}
                  ></div>
                  {/* Optional: Display percentage text if needed, consider placement */}
                  {/* <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-[10px] font-semibold text-white">
                    {positivePercentage.toFixed(0)}%
                  </div> */}
                </div>
              </div>
              <div className='flex items-center space-x-1'>
                <span className='text-xs font-medium text-muted-foreground'>
                  {negativeRatings}
                </span>
                <ThumbsDown className='h-4 w-4 text-red-500' />
              </div>
            </div>
          ) : (
            <p className='text-sm text-muted-foreground'>
              Ainda não há avaliações para esta estação.
            </p>
          )}

          {tags && tags.length > 0 && (
            <>
              <Separator className='bg-border/40' />
              <div className='space-y-2 pt-2'>
                <p className='text-sm font-semibold text-foreground/90'>
                  O que os usuários dizem?
                </p>
                <EVStationTags tags={tags} />
              </div>
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
